import Vue from 'vue';
import VueSplash from 'vue-splash';

Vue.use(VueSplash);
